import React, { useContext, useEffect, useState,useRef } from "react";
import { observer } from "mobx-react";
import Form from 'react-bootstrap/Form';
import Skeleton from 'react-loading-skeleton'
import { useTranslation, Trans } from "react-i18next";
import Stack from 'react-bootstrap/Stack';
import { NumericFormat } from 'react-number-format';
import { action } from "mobx";

const TimesheetInput = (props) => {
    const { t, i18n } = useTranslation();
    const [value, setValue] = useState("");
    const [touched, setTouched] = useState(false);
    const inputRef = useRef(null);
    const [defaultInit, setDefaultInit] = useState(false);

    useEffect(() => {
    }, [props.defaultValue]);

    useEffect(() => {        
        var v = props.value?.value;
        if (v) {            
            var val = v ?? "";            
            changeFormatted(val);
        } else {
            props.onChange?.("");
        }

        
    }, [props.value])

    const clear = () => {
        change("");
    }

    const updateValue = (val) => {            
        if (val == "0.00")
            val = null;
        
        setTouched(true);        
        change(val)
    }
    
    const changeFormatted = (val) => {
        var formatted = props.formatInitBlur?.(simpleRound(val));
        var parsed = parseFloat(formatted);

        props.formatInitBlur ? change(parsed !== 0 ? formatted : "") : updateValue(val)
    };
    const simpleRound = (val) => props.step == 0.25 ? roundToSpecificIntervals(val) : round(val, props.step, 0);
    const round = (number, increment, offset) => {
        if (!increment) { return number } else {
            var value = Math.ceil((number - offset) / increment) * increment + offset;
            return value;
        }
    }

    const roundToSpecificIntervals = (value) => {
        //if (typeof value !== 'number' || isNaN(value)) {
        //    console.warn("Input must be a valid number for roundToSpecificIntervals.");
        //    return value; // Or throw an error, depending on desired behavior for invalid input
        //}

        const integerPart = Math.floor(value);
        const decimalPart = (value - integerPart).toFixed(2); // Get the fractional part (e.g., 0.15 for 10.15)

        let roundedDecimal;

        if (decimalPart == 0.00 && integerPart == 0) {
            return null;
        }

        if (integerPart == 0 && decimalPart >= 0.00 && decimalPart <= 0.12) {
            return "";
        }

        if (decimalPart >= 0.00 && decimalPart <= 0.12) {
            roundedDecimal = 0.00;
        } else if (decimalPart >= 0.13 && decimalPart <= 0.37) {
            roundedDecimal = 0.25;
        } else if (decimalPart >= 0.38 && decimalPart <= 0.62) {
            roundedDecimal = 0.50;
        } else if (decimalPart >= 0.63 && decimalPart <= 0.87) {
            roundedDecimal = 0.75;
        } else { // decimalPart >= 0.88 (up to <1.00)
            // Round up to the next whole number
            return integerPart + 1.00;
        }

        // Combine the integer part with the rounded decimal part
        return integerPart + roundedDecimal;
    }

    const change = (v) => {
        setValue(v);
        props.onChange?.(v);
    }
    
    return (
        <Stack direction="vertical">
            {
                props.useFormattedInput ?
                    <NumericFormat
                        id={props.name}
                        style={props.isAmount ? { height: "22px", paddingLeft: "9px" } : { height: "22px", width: "45px", textAlign: "center", paddingRight: "0px", paddingLeft: "0px" }}
                        disabled={props.disabled}
                        readOnly={props?.readOnly === true ?? false}
                        name={props.name}
                        className={`hide-validation-icon form-control ${props?.className ?? ""}`}
                        placeholder={props.placeholder ? props.placeholder : ""}
                        value={value ?? ''}
                        onValueChange={action((values, sourceInfo) => {
                            updateValue(values?.value ?? "");
                        })}
                        onBlur={e => { updateValue(simpleRound(value)) }}
                        valueIsNumericString={true}
                        fixedDecimalScale
                        decimalScale={2}
                        allowLeadingZeros={true}
                        thousandSeparator="'"
                        decimalSeparator="."
                        onKeyDown={(e) => {
                            if (e.key === "Backspace" || e.key === "Delete") { clear(); }                            
                        }}

                    />
                    :
                    <Form.Control
                        readOnly={props?.readOnly === true ?? false}
                        type="text"
                        /*type="number"*/
                        className={`hide-validation-icon ${props?.className ?? ""}`}
                        onBlur={e => { changeFormatted(e.target.value) }}
                        value={value}
                        name={props.name}
                        style={props.isAmount ? { height: "22px", paddingLeft: "9px" } : { height: "22px", width: "40px", textAlign: "center", paddingRight: "0px", paddingLeft: "0px" }}
                        onKeyDown={(e) => {
                            //console.log(e.keyCode)
                            if (e.key == "Backspace" || e.key == "Delete") { clear(); }
                            else if (e.key === "Tab" || e.keyCode === 190 || e.keyCode === 110 || e.keyCode === 109 || e.keyCode === 35 || e.keyCode === 36 || e.keyCode === 37 || e.keyCode === 39) { }
                            else {
                                var isNumber = (e.key < 48 || e.key > 57)
                                if (e.key === "ArrowDown" || e.key === "ArrowUp" || !isNumber) { e.preventDefault(); e.stopPropagation() }
                            }
                        }}
                        onChange={(e) => { updateValue(e.target.value); }} />
            }
            </Stack>
    );
};

export default observer(TimesheetInput);
